import { FormControl, FormGroup } from '@angular/forms';
import { DocumentRequestStatusEnum } from '@enums/document-request-status.enum';
import { DocumentRequestFilters } from '@interfaces/document-request-filters';
import { AccountingPeriod } from '@models/accounting-period';

export type DocumentRequestFormType = {
  accountingPeriod: FormControl<AccountingPeriod>;
  documentRequestStatus: FormControl<DocumentRequestStatusEnum | 'all'>;
};

export class DocumentRequestFiltersForm extends FormGroup<DocumentRequestFormType> {
  get accountingPeriod(): FormControl<AccountingPeriod> {
    return this.controls.accountingPeriod;
  }

  get documentRequestStatus(): FormControl<DocumentRequestStatusEnum | 'all'> {
    return this.controls.documentRequestStatus;
  }

  constructor() {
    super({
      accountingPeriod: new FormControl<AccountingPeriod>(null),
      documentRequestStatus: new FormControl<DocumentRequestStatusEnum | 'all'>('all')
    });
  }

  toDocumentRequestFilters(): DocumentRequestFilters {
    return {
      accountingPeriod: this.accountingPeriod.value,
      documentRequestStatus: this.documentRequestStatus.value
    };
  }
}
